import { useSelector } from 'react-redux'

import { deployedBotVersionSelector } from '../../../features/hostingVersions/selectors/deployedVersionSelector'

export function useDeployedBotVersion() {
  return useSelector(deployedBotVersionSelector)
}
